<template>
  <div class="refund_box">
    <div class="refund">
      <div class="title">
        <div class="text">申请退款</div>
      </div>
      <div class="details">
        <div class="details_head">
          <div class="date">{{order_details.create_time}}</div>
          <div class="orders">订单号：{{order_details.orderCode}}</div>
        </div>
        <div class="content">
          <div class="list" v-for="item in parseproduct_list" :key="item.p_id">
            <div class="img">
              <img :src="item.images" alt />
            </div>
            <div class="list_title">
              <p class="p1">{{item.title}}</p>
              <p class="p2">货号 ： {{item.item_no}} 数量：{{item.number}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="feeback">
        <el-form
          ref="ruleForm"
          :rules="rules"
          style="margin-top:30px;padding-bottom: 40px;"
          label-width="140px"
        >
          <el-form-item label="商品数量:">
            <el-input-number :value="parseproduct_list.length" disabled></el-input-number>
          </el-form-item>
          <el-form-item label="退款原因:" prop="name">
            <!-- <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>-->
            <div class="return_money clearfix">
              <div
                class="return_money_list"
                :class="return_cause == item.label ? 'change_list' : ''"
                v-for="item in options"
                :key="item.value"
                @click="change_money_list(item.label)"
              >{{item.label}}</div>
            </div>
          </el-form-item>

          <el-form-item label="退款备注:">
            <el-input
              type="textarea"
              :autosize="{ minRows:4, maxRows: 6}"
              style="width:300px"
              placeholder="请输入内容"
              v-model="note"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传图片:">
            <el-upload
              action
              list-type="picture-card"
              :on-change="handle_img"
              :limit="3"
              :auto-upload="false"
            >
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb，最多上传三张图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="联系人:">
            <el-input style="width:200px" v-model="return_name"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:">
            <el-input v-model="return_mobile" style="width:200px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="hint_bom">
        <div class="submit">
          <el-button style="width:150px" type="primary" @click="submitForm('ruleForm')" plain>确认提交</el-button>
        </div>
        <div class="hint">
          <div class="hint_icon">
            <i class="iconfont icon-tanhao"></i>温馨提示
          </div>
          <div class="hint_text">. 退款申请提交后可在售后服务-申请记录中查询；</div>
          <div class="hint_text">. 退款处理成功后退款金额将原路返回到您的原支付账户中；</div>
        </div>
      </div>
    </div>
    <el-dialog
      center
      :show-close="false"
      style="padding:0"
      :visible.sync="dialogVisible"
      :modal="is_modal"
      width="300px"
    >
      <div style="text-align:center">
        <i class="iconfont icon-duihao11" style="color:#E2211C;font-size:40px"></i>
      </div>
      <div style="font-weight:400;color:#E2211C;text-align:center;line-height:26px">
        售后申请提交成功，我们会尽快处理！
        请注意查看消息通知！
      </div>
      <div style="text-align:center;margin-top:20px">{{modal_num}}秒后自动返回到售后服务页</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_modal: true,
      modal_num: 2,
      dialogVisible: false,
      return_name: "",
      return_mobile: "",
      order: this.$route.query.order,
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      order_details: {},
      img_link: [],
      parseproduct_list: [],
      rules: {
        name: [{ required: true }]
      },
      note: "",
      return_cause: "",
      options: [
        {
          value: "1",
          label: "配送信息有误"
        },
        {
          value: "2",
          label: "商品买错了"
        },
        {
          value: "3",
          label: "重复下单/误下单"
        },
        {
          value: "4",
          label: "忘记使用优惠券/积分等"
        },
        {
          value: "5",
          label: "其他渠道价格更低"
        },
        {
          value: "6",
          label: "不想买了"
        }
      ]
    };
  },
  created() {
    this.geting();
  },
  methods: {
    handle_img(file) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var formData = new FormData();
      formData.append("img", file.raw);
      this.axios
        .post(this.serve + "/admin/edit_upload_img", formData, config)
        .then(res => {
          this.img_link.push(res.data.data);
        });
    },
    change_money_list(e) {
      this.return_cause = e;
    },
    geting() {
      this.axios
        .get(this.serve + "/order/get_by_orderCode", {
          params: {
            token: this.token,
            mobile: this.mobile,
            orderCode: this.order
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.order_details = res.data.data;
            this.parseproduct_list = JSON.parse(res.data.data.product_list);
            this.return_name = res.data.data.link_name;
            this.return_mobile = res.data.data.link_mobile;
          }
        });
    },
    error(msg) {
      this.$message({
        type: "error",
        message: msg,
        offset: 200
      });
    },
    success(msg) {
      this.$message({
        type: "success",
        message: msg,
        offset: 200
      });
    },
    submitForm() {
      if (this.return_cause == "") {
        return this.error("请选择退款原因");
      }
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var formData = new FormData();
      formData.append("mobile", this.mobile);
      formData.append("token", this.token);
      formData.append("orderCode", this.order);
      formData.append("select_because", this.return_cause);
      formData.append("because", this.note);
      formData.append("image_list", JSON.stringify(this.img_link));
      formData.append("link_name", this.return_name);
      formData.append("link_mobile", this.return_mobile);
      const _this = this;
      this.axios
        .post(this.serve + "/order/order_return_money", formData, config)
        .then(res => {
          // this.dialogVisible = true;
          // _this.$router.push("/user/after/9");
          // return;
          if (res.data.status == "success") {
            this.dialogVisible = true;
            // this.success(res.data.msg);
            var num = 0;
            var time = setInterval(function() {
              num++;
              _this.modal_num--;
              if (num == 2) {
                //让弹窗在定时器之前消失，为了解决滚动条消失
                _this.dialogVisible = false;
              }
              if (num == 3) {
                _this.$router.push("/user/after/9");
                clearInterval(time);
                _this.is_modal = false;
              }
            }, 1000);
          } else {
            _this.error(res.data.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.refund_box {
  .refund {
    width: 960px;
    background: #fffeff;
    border: 1px solid rgba(221, 221, 221, 1);
    .title {
      height: 40px;
      line-height: 40px;
      width: 100%;
      background: #eeeeee;
      .text {
        text-align: center;
        color: #e2211c;
        width: 124px;
        background: #fffeff;
      }
    }
    .details {
      width: 900px;
      border: 1px solid rgba(221, 221, 221, 1);
      margin: 20px auto;
      .details_head {
        height: 50px;
        background: #fbf8fb;
        border-bottom: 1px solid rgba(221, 221, 221, 1);
        display: flex;
        align-items: center;
        padding-left: 24px;
        font-size: 12px;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        .date {
          color: rgba(153, 153, 153, 1);
        }
        .orders {
          margin-left: 20px;
          color: rgba(51, 51, 51, 1);
        }
      }
      .content {
        padding-left: 24px;
        .list {
          display: flex;
          height: 120px;
          align-items: center;
          img {
            width: 80px;
            height: 80px;
          }
          .list_title {
            margin-left: 19px;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 24px;
            .p1 {
              color: rgba(51, 51, 51, 1);
            }
            .p2 {
              color: #666666;
            }
          }
        }
      }
    }
    .feeback {
      width: 900px;
      border: 1px solid rgba(221, 221, 221, 1);
      margin: 20px auto;
      .return_money {
        .return_money_list {
          width: 180px;
          height: 38px;
          background: rgba(255, 255, 255, 0);
          border: 1px solid rgba(221, 221, 221, 1);
          border-radius: 4px;
          font-size: 14px;
          font-family: " Microsoft YaHei";
          text-align: center;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          float: left;
          /* margin-left: -20px; */
          margin-right: 20px;
          margin-bottom: 20px;
          cursor: pointer;
        }
        .return_money_list:hover {
          border: 1px solid #e2211c;
          color: #e2211c;
        }
        .change_list {
          border: 1px solid #e2211c;
          color: #e2211c;
        }
      }
    }
    .hint_bom {
      .hint {
        line-height: 40px;
        padding-left: 50px;
        padding-bottom: 100px;
        .hint_icon {
          color: #666666;
          font-size: 14px;
          font-family: "Microsoft YaHei";
          font-weight: 400;
        }
        .hint_text {
          font-size: 14px;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }
      .submit {
        width: 150px;
        margin: 0 auto;
        padding: 50px 0 50px 0;
      }
    }
  }
}
</style>